<div class="row ng-scope">
  <div class="col-12">


    <div class="row form-group">
      <label class="control-label col-3 ng-binding">{{'Ngày hết hạn' | translate}}</label>
      <div class="col-9">
        <!--<kendo-dateinput tabIndex="6" style="width:100%;" [format]="'dd/MM/yyyy HH:mm'" [(value)]="ngayhethan"></kendo-dateinput>-->
      </div>
    </div>


  </div>
    
</div>
<div class="modal-footer" style="display: flex;justify-content: space-between;">
        <div class="checkbox c-checkbox">
                <!--<label>
                        <input tabIndex="5" type="checkbox" [(ngModel)]="doituongSelect.Trang_Thai" />
                    <span class="fa fa-check"></span>{{hoatdong}}</label>-->
            </div>
    <div class="">
      <button style="float:left !important" class="mb-1 mr-1 btn btn-secondary" (click)="closeModal()" title="">{{'Hủy bỏ' | translate}}</button>
      <button style="float:left !important" type="submit" (click)="saveproduct()" title="" class="mb-1 mr-1 btn btn-primary">{{'Lưu lại' | translate}}</button>
    </div>
    
</div>


